<template>
  <div class="transfer-device-dialog">
    <custom-dialog width="900px" :title="model.title" :visible="visible" v-on="$listeners">
      <div class="dialog-body">
        <div class="item-title">{{ $t('dms_device_update_dialog.qxzbzcjmsjdbj') }}</div>
        <div class="ub">
          <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">{{ $t('Common.com_sel_all') }}</el-checkbox>
          <div style="margin-right: 24px"></div>
          <el-checkbox-group v-model="checked" @change="handleCheckedCitiesChange">
            <el-checkbox v-for="item in componentList" :label="item.componentCode" :key="item.componentCode">{{ item.componentName }}</el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
        <el-button type="primary" @click="confirm">{{ $t('Common.com_confirm') }}</el-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      checkAll: false,
      isIndeterminate: false,
      checked: [],
      componentList: [],
    };
  },
  mounted() {
    this.getFwList();
  },
  methods: {
    getFwList() {
      this.checked = this.model.row.notSilentComponent ? this.model.row.notSilentComponent.split(',') : [];
      this.$getJSON(apis.DeviceFwList, { bodyNum: this.model.row.bodyNum }).then((res) => {
        this.componentList = res.data;
      });
    },
    handleCheckAllChange(val) {
      this.checked = val ? this.componentList.map(t => t.componentCode) : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      const checkedCount = value.length;
      this.checkAll = checkedCount === this.componentList.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.componentList.length;
    },
    // 提交
    confirm: function () {
      this.$postJSON(apis.DeviceSetSilentUpgrade, {
        deviceId: this.model.row.deviceId,
        notSilentComponent: this.checked.length ? this.checked.join(',') : '',
      }).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.visible = false;
        this.$emit('success');
      });
    },
  },
};
</script>

<style lang="scss"></style>
